<template>
  <section>
    <b-row>
      <b-form-group class="col-12" label="For:" description="From Date must be before To Date">
        <b-form-select :disabled="viewOnly" v-model="reportFilters.dateFilter" :options="projectDateOpts" required />
      </b-form-group>
      <template v-if="reportFilters.dateFilter == 'custom'">
        <div class="col-12 alert alert-warning">
          <b>Explanation</b>: Setting the dates as 01/01/2000 -
          01/07/2000, will check all orders shipped <b>on or after</b> the
          1st and <b>before</b> the 7th of January.
        </div>
        <b-form-group class="col-sm-6" label="From Shipped Date:" description="From Date must be before To Date">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.startDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" name="startDate" required />
        </b-form-group>
        <b-form-group class="col-sm-6" label="To Date (excluded!):">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.endDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" required />
        </b-form-group>
      </template>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  data() {
    return {
      projectDateOpts: [
        // { value: '', text: "All" },
        { value: 'this-week', text: 'This Week' },
        { value: 'last-week', text: 'Last Week' },
        { value: 'this-month', text: 'This Month' },
        { value: 'last-month', text: 'Last Month' },
        { value: 'custom', text: 'Custom Date Range' }
      ],
      flatpickrConfig: {
        altFormat: 'j F Y',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  }
}
</script>

<style>

</style>
